import { numericIdFn, numericIdStudentIdFn } from './_utils'

const routes = [

  // {
  //   path: '/pk',
  //   name: 'pk-login',
  //   component: () => import(/* webpackChunkName: "pk-login" */ '@/views/pk/Login.vue')
  // },
  {
    path: '/pk',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "pk-layout" */ '@/views/pk/_Layout.vue'),
    children: [

      {
        path: '',
        name: 'pk-root',
        redirect: { name: 'pk-home' }
      },

      {
        path: 'forside',
        name: 'pk-home',
        component: () => import(/* webpackChunkName: "pk-home" */ '@/views/pk/Home.vue')
      },

      // practice periods

      {
        path: 'praksisperioder',
        name: 'pk-practiceperiod-list',
        component: () => import(/* webpackChunkName: "pk-practiceperiod-list" */ '@/views/pk/PracticePeriod_List.vue')
      },
      {
        path: 'praksisperioder/opprett',
        name: 'pk-practiceperiod-create',
        component: () => import(/* webpackChunkName: "pk-practiceperiods-create" */ '@/views/pk/PracticePeriod_Create.vue')
      },
      {
        path: 'praksisperioder/:id',
        name: 'pk-practiceperiod-edit',
        props: numericIdFn,
        component: () => import(/* webpackChunkName: "pk-practiceperiod-edit" */ '@/views/pk/PracticePeriod_Edit.vue')
      },

      // students

      {
        path: 'studenter',
        name: 'pk-students-list',
        component: () => import(/* webpackChunkName: "pk-students-list" */ '@/views/pk/Student_List.vue')
      },
      {
        path: 'studenter/opprett/:id',
        name: 'pk-students-create',
        props: numericIdFn,
        component: () => import(/* webpackChunkName: "pk-students-create" */ '@/views/pk/Student_Create.vue')
      },
      {
        path: 'studenter/:id/:studentId',
        name: 'pk-students-edit',
        props: numericIdStudentIdFn,
        component: () => import(/* webpackChunkName: "pk-students-edit" */ '@/views/pk/Student_Edit.vue')
      },
      {
        path: 'resultater',
        name: 'pk-students-results',
        component: () => import(/* webpackChunkName: "pk-results" */ '@/views/pk/Results.vue')
      },

      // specials

      {
        path: 'saerplasser',
        name: 'pk-special-list',
        component: () => import(/* webpackChunkName: "pk-special-list" */ '@/views/pk/Special_List.vue')
      },
      {
        path: 'saerplasser/opprett',
        name: 'pk-special-create',
        component: () => import(/* webpackChunkName: "pk-special-list" */ '@/views/pk/Special_Create.vue')
      },

      // wishes

      {
        path: 'onsker',
        name: 'pk-wishes',
        component: () => import(/* webpackChunkName: "pk-wishes" */ '@/views/pk/Wishes.vue')
      },


    ]
  },

]

export default routes